import { useEffect } from 'react';
export const useOutsideClick = (refs, onOutsideClickCallback) => {
  useEffect(() => {
    function handleClickOutside(event) {
      const outsideClick = refs.every(ref => !ref.current || !ref.current.contains(event.target));
      if (outsideClick) {
        onOutsideClickCallback();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onOutsideClickCallback, refs]);
};